var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('login-form',{attrs:{"wrong":_vm.wrongLogin,"loginMessage":_vm.loginMessage,"disabled":_vm.loading},on:{"login":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }